module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_06 (1).ce747c97.png";